import { z } from 'zod';
export const TIPOS_DESCUENTO = ['BANCO', 'ESCUELA', 'PROMOCION', 'OTRO'];
export const TIPOS_CLASE_DISPONIBLES = ['PRIVADA', 'GRUPAL', 'EMPRESA'];
export const DescuentoReglaSchema = z.object({
    id: z.string().uuid(),
    tipo: z.string(),
    codigo: z.string(),
    nombre: z.string(),
    descripcion: z.string().nullable().optional(),
    pct: z.union([z.string(), z.number()]).nullable().optional(),
    montoFijo: z.union([z.string(), z.number()]).nullable().optional(),
    vigenteDesde: z.string().nullable().optional(),
    vigenteHasta: z.string().nullable().optional(),
    soloTiposClase: z.array(z.string()).nullable().optional(),
    soloMetodosPago: z.array(z.string()).nullable().optional(),
    montoMinimo: z.union([z.string(), z.number()]).nullable().optional(),
    activo: z.boolean(),
});
export const TIPOS_VALOR_DESCUENTO = ['PCT', 'MONTO_FIJO'];
export const DescuentoReglaFormSchema = z
    .object({
    tipo: z.enum(TIPOS_DESCUENTO),
    codigo: z
        .string()
        .trim()
        .min(3, 'Mínimo 3 caracteres')
        .max(40, 'Máximo 40 caracteres')
        .regex(/^[A-Z0-9_-]+$/, 'Solo mayúsculas, números, guion o guion bajo'),
    nombre: z.string().trim().min(1, 'Requerido').max(150),
    descripcion: z.string().max(2000).optional().or(z.literal('')),
    tipoValor: z.enum(TIPOS_VALOR_DESCUENTO),
    valor: z.string().min(1, 'Requerido'),
    vigenteDesde: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD')
        .optional()
        .or(z.literal('')),
    vigenteHasta: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD')
        .optional()
        .or(z.literal('')),
    soloTiposClase: z.array(z.string()).default([]),
    soloMetodosPago: z.array(z.string()).default([]),
    montoMinimo: z.string().optional().or(z.literal('')),
})
    .refine((v) => {
    const n = Number(v.valor);
    if (!Number.isFinite(n) || n <= 0)
        return false;
    if (v.tipoValor === 'PCT')
        return n <= 100;
    return true;
}, { path: ['valor'], message: 'Valor inválido.' });
